import { jsxs, jsx } from 'react/jsx-runtime';
import { isNil } from '@flex-design-system/fx-utils/common';
import { styled } from '@flex-design-system/stitches-react';
import * as LabelPrimitive from '@radix-ui/react-label';
import classNames from 'classnames';
import { forwardRef } from 'react';
import '../../utils/styles/flex.mjs';
import Stack from '../../utils/styles/stack.mjs';
import { labelIconRoot, labelRoot } from './label_legacy.vanilla.mjs';

const Label_Legacy = forwardRef(
  (props, ref) => {
    const {
      children,
      className,
      disabled,
      leftSlot,
      rightSlot,
      required,
      state = "default",
      ...labelProps
    } = props;
    return /* @__PURE__ */ jsxs(
      StyledLabelRoot,
      {
        ...labelProps,
        className: classNames(
          labelRoot({ state, disabled, required }),
          className
        ),
        ref,
        children: [
          /* @__PURE__ */ jsxs(Stack.Horizontal, { space: 4, children: [
            !isNil(leftSlot) && /* @__PURE__ */ jsx("div", { className: labelIconRoot({ state }), children: leftSlot }),
            children
          ] }),
          rightSlot
        ]
      }
    );
  }
);
const StyledLabelRoot = styled(LabelPrimitive.Root);

export { Label_Legacy as default };
//# sourceMappingURL=Label_Legacy.mjs.map
